<!-- src/views/statistics/components/ReportMenu.vue -->
<template>
  <div class="report-menu">
    <h4 class="section-title">统计报表</h4>
    <p class="section-desc">选择以下报表查看详细数据，支持筛选、排序和导出</p>
    
    <div class="report-list">
      <div 
        class="report-item" 
        v-for="report in reports" 
        :key="report.name"
        @click="$emit('select-report', report.name)"
      >
        <div class="report-content">
          <div class="report-icon" :style="{ background: report.color + '15', color: report.color }">
            <i :class="report.icon"></i>
          </div>
          <div class="report-info">
            <div class="report-title">{{ report.title }}</div>
            <div class="report-desc">{{ report.description }}</div>
          </div>
          <div class="report-action">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportMenu",
  data() {
    return {
      reports: [
        {
          name: 'feedback',
          title: '用户交流明细报表',
          description: '查看和管理用户反馈，追踪问题处理进度',
          icon: 'el-icon-message',
          color: '#409EFF'
        },
        {
          name: 'knowledge-performance',
          title: '知识库文档表现报表',
          description: '分析每篇知识文档的使用效果和用户满意度',
          icon: 'el-icon-document',
          color: '#67c23a'
        },
        {
          name: 'hot-search',
          title: '热门搜索与命中分析',
          description: '了解用户最常搜索的问题及其命中情况',
          icon: 'el-icon-search',
          color: '#e6a23c'
        },
        {
          name: 'unknown-questions',
          title: '未知问题TOP榜',
          description: '发现知识库盲区，优化知识内容覆盖',
          icon: 'el-icon-question',
          color: '#f56c6c'
        },
        {
          name: 'conversation-detail',
          title: '会话全链路明细报表',
          description: '查看完整对话记录，追踪用户服务旅程',
          icon: 'el-icon-s-order',
          color: '#722ed1'
        }
      ]
    }
  }
}
</script>

<style scoped>
.report-menu {
  padding: 0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  padding-left: 10px;
  border-left: 3px solid #409EFF;
}

.section-desc {
  color: #909399;
  font-size: 14px;
  margin-bottom: 20px;
}

/* 改为垂直列表布局 */
.report-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.report-item {
  background: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #ebeef5;
}

.report-item:hover {
  transform: translateX(4px);
  border-color: #409EFF;
  box-shadow: 0 2px 12px rgba(64, 158, 255, 0.1);
}

.report-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.report-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}

.report-info {
  flex: 1;
  min-width: 0;
}

.report-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
  /* 标题过长时省略号显示 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.report-desc {
  font-size: 13px;
  color: #909399;
  line-height: 1.4;
  /* 描述过长时省略号显示 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.report-action {
  color: #dcdfe6;
  font-size: 18px;
  flex-shrink: 0;
  transition: color 0.2s;
}

.report-item:hover .report-action {
  color: #409EFF;
}
</style>